<div>
    <h2>Select</h2>
    <select class="select">
        <option class="">Option 1</option>
        <option value="">Option 2</option>
        <option value="">Option 3</option>
        <option value="">Option 4</option>
    </select>
</div>
